import InspectionPanel from "./InspectionPanel.container";
export default InspectionPanel;
